module.exports = __webpack_public_path__ + "static/media/layout-3.fdd0efd5.jpg";